export const nextSubscription = (subscriptions, current_subscription_id) => {
  let target = -1;
  for (let i = 0; i < subscriptions?.length; i++) {
    if (current_subscription_id === subscriptions[i].subscription_id) {
      target = i;
      break;
    }
  }

  if (target === -1) return -1;
  else {
    if (target === subscriptions.length - 1) return -1;
    else {
      let months =
        ((subscriptions[target + 1]?.expires_at -
          subscriptions[target + 1]?.started_at) /
          (1000 * 60 * 60 * 24) +
          1) /
        30;
      let upcomingPlan = -1;
      if (subscriptions[target + 1]?.role_type === "pro")
        upcomingPlan = "LearnTube Pro";
      else if (subscriptions[target + 1]?.role_type === "pro_plus")
        upcomingPlan = "LearnTube Pro+";
      else if (subscriptions[target + 1]?.role_type === "x")
      upcomingPlan = "LearnTubeX";
      else if (subscriptions[target + 1]?.role_type === "max")
      upcomingPlan = "LearnTube Max";
      else if (subscriptions[target + 1]?.role_type === "max_trial")
      upcomingPlan = "LearnTube Max Trial";

      if(Math.round(months < 0)) return `${upcomingPlan} 7 days`;
      else if (Math.round(months < 2)) return `${upcomingPlan} 1-Month`;
      else if (Math.round(months) >= 2 && Math.round(months) <= 4)
        return `${upcomingPlan} 3-Months`;
      else return `${upcomingPlan} 6-Months`;
    }
  }
};

export const getDayDecor = (day) => {
  if (day % 10 === 1 && (day < 10 || day>20)) return "st";
  else if (day % 10 === 2 && (day < 10 || day>20)) return "nd";
  else if (day % 10 === 3 && (day < 10 || day>20)) return "rd";
  else return "th";
};




export function capitalizeWords(sentence) {
  if(!sentence) return '';
  return sentence
    .trim()
    .split(/\s+/)
    .map(word =>
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(' ');
}

export function formatWithComma(num) {
  return num.toLocaleString('en-IN');
}
